<template>
    <div id="accordion" role="tablist" style="margin:2em 1em;">
      <div class="card" >
        <div class="card-header" role="tab" id="headingOne">
          <h5 class="mb-0">
            <a href="" @click.prevent="toggleCollapse()" aria-expanded="true" aria-controls="test">
              
              <span v-if="" style="color: rgba(0,0,0,.6); font-weight:bold;">{{currentActiveLinkName}}</span>
              <span class="fa fa-bars fa-lg" style="color:rgba(0, 0, 0,.6); float:right; padding-top: 0.1em;"></span>
            </a>
          </h5>
        </div>
        
        <transition name="collapse">
          <div v-if="!collapse" @click.prevent="toggleCollapse()" role="tabpanel" aria-labelledby="headingOne" data-parent="#accordion">
            <div class="card-body">
              <ul class="nav flex-column justify-content-center">
                <li class="nav-item" @click="">
                  <router-link :to="{ name: 'IntroductionLink' }" class="nav-link">Introduction</router-link>
                </li>
                <li class="nav-item">
                  <router-link to="" class="nav-link" ><span style="color:rgba(0,0,0,.2)">Chapter:</span></router-link>
                </li>
                
                <div v-for="item in currentChapterNavi" style="padding-left: 1em">
                  <div v-if="item.chapterLinkClass == 'nav-link disabled'">
                    <a :class="item.chapterLinkClass">{{ item.chapterName }} 
                      <!--<span> / {{ item.chapterTime }} min</span>-->
                      <span><i class="fa fa-clock-o" aria-hidden="true"></i> ~{{ item.chapterTime }} min</span>
                    </a>  
                    
                  </div>
                  <div v-else>
                    <li @click="setChapter(item.chapterId)">
                      <router-link :class="item.chapterLinkClass" :to="{path: '/course/' + getLCData.id + '/chapter/' + item.chapterId+ '/materials/'}">
                      {{ item.chapterName }} 
                      <span style="color:rgba(0,0,0,.2)"><i class="fa fa-clock-o" aria-hidden="true"></i> ~{{ item.chapterTime }} min</span>
                      <!--<span style="color: rgba(0,0,0,.2); font-weight:regular"> / {{ item.chapterTime }} min</span>-->
                      </router-link>
                    </li>
                  </div>
                </div>
                
                <li class="nav-item">
                  <div v-if="chapterCert">
                    <router-link style="color:rgba(0,0,0,.6)" class="nav-link" :to="{path: '/course/' + getLCData.id + '/certificate/'}">
                      Certificate
                    </router-link> 
                  </div>
                  <div v-else>
                    <span class="nav-link disabled">Certificate</span>
                  </div>
                </li>
                
              </ul>
            </div>
          </div>
        </transition>
        
      </div>
    </div>
</template>


<script>
import { store } from '../../store/store.js'

export default {
  data() {
    return {
      currentActiveLinkName: '',
      collapse: true,
      currentChapterNavi: [],
      chapterCert: false
    }
  },
  props:['LCData','UserSubmissionData'],
  methods: {
    setChapter(chapterId) {
      // console.log(chapterId);
      store.dispatch('setChapter', chapterId);
    },
    setActiveLinkName(name){
      this.currentActiveLinkName = name;
    },
    setChapterNavi(chapterNavi){
      this.currentChapterNavi = chapterNavi;
    },
    toggleCollapse(){
      this.collapse = ! this.collapse;
    },
    
    getRoute(route) {

      var LCData = this.LCData
      var chapterData = LCData.chapter;
      var chapterNavi = [];
      var UserSubmissionData = this.UserSubmissionData;
      var CurrentUsersSubmissionsInChapter = UserSubmissionData.filter( CurrentUsersSubmissionsInChapter => {
          return  (
              CurrentUsersSubmissionsInChapter.lCId == parseInt(LCData.id)
          );
      });
      
      
      // if(UserSubmissionData[0].chapterId === 0){
      //   console.log("chaperID 0")
      // }

      if('chapterId' in route.params){
        var chapterId = route.params.chapterId;

        this.setActiveLinkName(LCData.chapter[chapterId].chapterName)
        
        if (chapterData.length===CurrentUsersSubmissionsInChapter.length) {
            this.chapterCert = true
        } else {
            this.chapterCert = false
        }
        
        
        // console.log("chapterId")
        // console.log(chapterId)
        for (var i = 0; i < chapterData.length; i++) {
          // console.log("chapterData[i].chapterId")
          // console.log(chapterData[i].chapterId)
          // console.log("chapterId")
          // console.log(parseInt(chapterId))
          var chapterLinkClass = 'nav-link'
          if(chapterData[i].chapterId === parseInt(chapterId)){
            chapterLinkClass = 'nav-link active'
          }
          
          if (i > CurrentUsersSubmissionsInChapter.length){
            chapterLinkClass = 'nav-link disabled'
          }
          

          chapterNavi.push({
            'chapterName': chapterData[i].chapterName,
            'chapterTime': chapterData[i].chapterTime,
            'chapterId': chapterData[i].chapterId,
            'chapterLinkClass': chapterLinkClass,
          })
          //console.log("chapterNavi")
          //console.log(chapterNavi)
          this.setChapterNavi(chapterNavi)
        }
        
      } else {
        var linkName = route.name
        var linkNameFiltered = linkName.replace('Link','');
        this.setActiveLinkName(linkNameFiltered);
        
        chapterLinkClass = 'nav-link'
        
        for (var j = 0; j < chapterData.length; j++) {
          if (j > CurrentUsersSubmissionsInChapter.length){
            chapterLinkClass = 'nav-link disabled'
          }
          chapterNavi.push({
            'chapterName': chapterData[j].chapterName,
            'chapterTime': chapterData[j].chapterTime,
            'chapterId': chapterData[j].chapterId,
            'chapterLinkClass': chapterLinkClass
            
          })
        }
        this.setChapterNavi(chapterNavi)
      }
      
    },
  },
  watch:{
    '$route' (to){
      this.getRoute(to);
    }
  },
  created() {
    // update navigation on first page load
    // this.getRoute(this.$route);
    this.getRoute(this.$route);
  },
  computed: {
    getLCData() {
        var courseId = parseInt(this.$route.params.courseId)
        return this.$store.getters.getCurrentLCData2(courseId)
    },

    // getChapterData() {
    //     var asd = this.$store.getters.getCurrentChapterData()
    //     console.log(asd)
    //     return asd;    
    // },
  }
}
</script>

<style scoped>
  /**
    Animation goes here
   */
  .collapse-enter-active,
  .collapse-leave-active {
    transition: all .2s;
    max-height: 500px;
  }
  .collapse-enter,
  .collapse-leave-to
  {
    opacity: 0;
    max-height: 0px;
  }
.nav-link {
    color: rgba(0,0,0,.6);
    padding: -1em 0;
}

.disabled {
    color: rgba(0,0,0,.2);
}

.nav-link.active {
    font-weight: bold;
    padding: -1em 0;
}

.nav-link.disabled {
    color: rgba(0,0,0,.2);

}
</style>



// WEBPACK FOOTER //
// src/components/course/CourseNavigation.vue